import { Box, Button, Flex, Image, Spacer } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

// Icons
import { MdExitToApp } from "react-icons/md";

// Images
import Logo from '../../Assets/Logos/logoL.webp';

// Services
import { postData } from '../../Services/api';

const AdminNavbar = () => {

    const navigate = useNavigate();

    const infoUser = JSON.parse(localStorage.getItem('infoUser'));

    const exitSession = async () => {
        await postData('logout', {});
        localStorage.removeItem('login');
        localStorage.removeItem('token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem('infoUser');
        navigate('/Login');
    }

    return (
        <Box h="auto" boxShadow="lg">
            <Flex p="3" h="100%">
                <Flex my='auto' w='100px' h='100%'><Image src={Logo} w='100%'/></Flex>
                {
                    infoUser.rol === 'Administrador' && 
                    <Button my='auto' ml='5' onClick={() => navigate('/Admin/Dashboard')} className='Subtitle' bg='transparent' border='2px solid #FD3D00' color='#FD3D00' _hover={{bg:'#FD3D00', color:'white'}}>
                        Dashboard
                    </Button>
                }

                <Spacer />

                <Button bg="#E4002B" color='white' className='Subtitle' _hover={{border: '2px solid #E4002B', color: '#E4002B', bg: 'white'}} fontWeight="bold" leftIcon={<MdExitToApp size="20px" />} m="auto" onClick={exitSession} mr="5">
                    Cerrar sesión
                </Button>
            </Flex>
        </Box>
    )
}

export default AdminNavbar